import { createSlice } from "@reduxjs/toolkit";

export const name = "destination-type";

const initialState = {
  destinationTypes: [],
};

const destinationTypeSlice = createSlice({
  name,
  initialState,
  reducers: {
    setDestinationTypes: (state, action) => {
      const foundDestinationType = state.destinationTypes.find(
        (item) => item.rowId === action.payload.rowId
      );
      if (foundDestinationType) {
        Object.assign(foundDestinationType, action.payload);
      } else
        state.destinationTypes.push({
          rowId: action.payload.rowId,
          destinationType: action.payload.destinationType,
        });
    },
  },
});

export const destinationTypeSelector = (rowId) => (state) =>
  state[name]?.destinationTypes.find((item) => item.rowId === rowId)
    ?.destinationType;
export const { setDestinationTypes } = destinationTypeSlice.actions;

export const generateStoreRowId = (rowId, rule) => `${rowId}-${rule}`;
export default destinationTypeSlice.reducer;
